import type {EmptySWResponse, SWGeneratorReturn} from '../types/generators'

export const checkIfNonValidResponse = <K>(event: SWGeneratorReturn<K>): event is EmptySWResponse =>
  event &&
  (event as EmptySWResponse).meta &&
  Boolean((event as EmptySWResponse).meta.NO_NEW_DATA || (event as EmptySWResponse).meta.timeout)
